import { lazy } from "react";

export const AccountPaymentAsync = lazy(() => import("./AccountPayment"));
